import { render, staticRenderFns } from "./Attribute.vue?vue&type=template&id=c05a2c0e&scoped=true&"
import script from "./Attribute.vue?vue&type=script&lang=js&"
export * from "./Attribute.vue?vue&type=script&lang=js&"
import style0 from "../../../Style/data-attribute.scss?vue&type=style&index=0&id=c05a2c0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05a2c0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c05a2c0e')) {
      api.createRecord('c05a2c0e', component.options)
    } else {
      api.reload('c05a2c0e', component.options)
    }
    module.hot.accept("./Attribute.vue?vue&type=template&id=c05a2c0e&scoped=true&", function () {
      api.rerender('c05a2c0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/IoFormat/Components/Formats/Entity/Attribute.vue"
export default component.exports